<template>
  <v-container style="max-width: 1280px">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <v-card outlined>
          <v-card-subtitle>
            Step 5 / 5
          </v-card-subtitle>
          <v-progress-linear height="10" :value="100" striped></v-progress-linear>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12">
        <v-card outlined>
          <v-card-title class="justify-center">
            People, Events, and Memories
          </v-card-title>
          <v-card-subtitle class="text-center">
            Click <strong>Add Item</strong> to get started.
          </v-card-subtitle>
          <v-divider></v-divider>
          <v-card-text v-if="items.length == 0">
            <v-alert class="mb-0" type="info">
              Add, good people, events, and memories in your life.
            </v-alert>
          </v-card-text>
          <v-form v-model="name_valid" v-else>
            <!-- Mobile List -->
            <template v-if="$vuetify.breakpoint.mobile">
              <v-card v-for="(item, index) in items" :key="'item-' + index" outlined>
                <v-container fluid>
                  <v-row justify="center">
                    <v-col cols="12">
                      <v-text-field
                        label="Name/Description"
                        :id="`name-${index}`"
                        placeholder="Enter a name or brief description."
                        v-model="item.name"
                        :rules="name_rules"
                        dense outlined hide-details
                      />
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12">
                      <v-text-field
                        label="Percentage of Your Life"
                        v-model.number="item.value"
                        :rules="value_rules"
                        min="1"
                        max="100"
                        type="number"
                        dense hide-details outlined
                      />
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12">
                      <v-btn color="error" @click="remove_item(index)" block>
                        <v-icon>
                          mdi-close-box
                        </v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </template>

            <!-- Desktop List -->
            <v-list v-else two-line>
              <template v-for="(item, index) in items">
                <v-list-item :key="'item' + index">
                  <v-list-item-content>
                    <v-list-item-title class="d-flex flex-row mb-4">
                      <v-text-field
                        :id="`name-${index}`"
                        class="mr-4 mt-1"
                        placeholder="Enter a name or brief description."
                        v-model="item.name"
                        :rules="name_rules"
                        label="Name/Description"
                        dense outlined hide-details
                      />
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <v-card class="px-3 py-1 mr-4" outlined>
                        <v-slider
                          class=""
                          v-model.number="item.value"
                          height="50px"
                          :step="1"
                          :min="1"
                          :max="100"
                          label="Percentage of Life"
                          dense hide-details
                        >
                        <template v-slot:append>
                          <v-text-field
                            v-model.number="item.value"
                            type="number"
                            style="width: 60px"
                            dense hide-details outlined
                          />
                          </template>
                        </v-slider>
                      </v-card>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon color="error" @click="remove_item(index)">
                      mdi-close-box
                    </v-icon>
                  </v-list-item-action>
                </v-list-item>
                <v-divider v-if="index < items.length - 1" :key="'divider-' + index"></v-divider>
              </template>
            </v-list>
          </v-form>
          <v-divider></v-divider>
          <v-card-actions class="pa-4">
            <v-btn class="mr-2" color="primary" @click="add_item">
              Add item
            </v-btn>
            <v-btn color="success" :disabled="!name_valid" @click="finish">
              Continue
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'items',
  data: () => ({
    // Dropdowns for each question.
    choices: [
      'Bad',
      'Ok',
      'Good'
    ],

    name_valid: true,
    name_rules: [
      v => !!v || 'Name is required',
      v => (v && v.length <= 10) || 'Name must be less than 100 characters',
    ],
    value_rules: [
      v => !!v || 'Value is required',
      v => (v && v >= 1 && v <= 100) || 'Value must be between 1 and 100.',
    ],
      
    items: []
  }),
  computed: {
    total_points: function() {
      var bad = 0;
      var ok = 0; 
      var good = 0;

      this.items.forEach(item => {
        if (item.type === 'Bad') {
          bad += item.value;
        }
        else if (item.type === 'Ok') {
          ok += item.value;
        }
        else {
          good += item.value;
        }
      });

      return {
        bad: bad,
        ok: ok,
        good: good,
        sum: bad + ok + good
      }
    },

    points_frac: function() {
      var points = this.total_points;

      return {
        bad: points.bad /   points.sum,
        ok: points.ok /     points.sum,
        good: points.good / points.sum
      }
    }
  },
  methods: {
    add_item: function() {
      this.items.push({
        name: '',
        value: 1,
        type: 'Good'
      });

      //document.getElementById(`name-${this.items.length - 1}`).$el.focus();
    },

    remove_item: function(index) {
      this.items.splice(index, 1);
    },

    finish: function() {
      var query = this.$route.query;

      var responses = [];
      this.items.forEach(item => {
        responses.push({
          question: item.name,
          category: "People/Events",
          response: item.type
        });
      });

      var values = JSON.stringify({
        responses: responses,
        points: this.total_points
      });
      
      this.$router.push({
        path: 'results',
        query: {
          major_issue: query.major_issue,
          initial: query.initial,
          general: query.general,
          refined: query.refined,
          items: values
        }
      });
    }
  }
}
</script>